module.exports = __webpack_public_path__ + "static/img/btn1.3d5faae.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn1.png
// module id = W4Jb
// module chunks = 1